import React, { useMemo } from 'react';
import classnames from 'classnames';
import { useIntl, getLocale } from 'umi';
import {
  // Button,
  StatusTip,
} from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import NoData from '@intelligence/components/NoData';
import CardSlotV2 from '@intelligence/components/CardSlotV2';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import {
  SUMMARY_SOURCE_LIST,
  PCCONSOLE_SOURCE_LIST,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/OverlapSteam/constants/metrics';

import './index.scss';

const { LoadingTip } = StatusTip;

interface SummeryProps {
  subTitle?: string;
  loading?: boolean;
  isSourceTips?: boolean;
  /**
   * 是否展示右上角的关闭按钮，默认值为false
   */
  showCloseBtn?: boolean;
  openSource?: boolean;
  strList?: any[];
  summarySourceKeyList?: string[];
  summarySourceList?: string[][];
  /**
   * 点击右上角关闭按钮的回调
   */
  onClose?: () => void;
}

/** Summary卡片，通用组件
 * 关键参数strList格式：
 * [
        {
          type: 'normal', //普通文本
          strKey: metricSummaryObj.textFrontKey,
        },
        {
          type: 'yellow', //黄色高亮文本
          strKey: topFiveNames,
        },
        ...
      }
 ***/

const Summary: React.FC<SummeryProps> = (props) => {
  const {
    loading = false,
    subTitle,
    isSourceTips = false,
    showCloseBtn = false,
    openSource = false,
    strList = [],
    summarySourceKeyList,
    summarySourceList,
    onClose,
  } = props;

  const locale = getLocale();
  const sourceList = summarySourceKeyList ?? PCCONSOLE_SOURCE_LIST;

  const { formatMessage } = useIntl();

  const sourceIconTitle = (indexKey: number) => {
    if (!Array.isArray(sourceList) || sourceList.length <= indexKey) return null;
    const iconKey = sourceList?.[indexKey] || '';
    return (
      <div className="summary-source-title-content">
        <img src={getDataSourceIcon(iconKey)} alt="" />
        <span className="">{iconKey}</span>
      </div>
    );
  };

  const strListCur = useMemo(() => {
    if (isSourceTips) {
      const sourceSummaryList: any = [];
      (summarySourceList ?? SUMMARY_SOURCE_LIST)?.forEach((sourceList: any[]) => {
        const listTemp = sourceList?.map((item: any, index: number) => {
          if (index % 2 === 0) {
            return {
              type: 'normal',
              strKey: item,
            };
          }
          return {
            type: 'yellow',
            strKey: item,
            highColor: 'yellow-highlight',
          };
        });
        sourceSummaryList.push(listTemp);
      });
      return sourceSummaryList;
    }
    return strList;
  }, [locale, strList, summarySourceList]);

  const getListContent = () => {
    return strListCur?.map((itemList: any, index: number) => {
      return (
        <div className={isSourceTips ? 'summary-scource-content' : 'summary-content'} key={index}>
          {isSourceTips ? sourceIconTitle(index) : null}
          {itemList?.map((itemSub: any, subIndex: number) => {
            return (
              <React.Fragment key={`${index}-${subIndex}`}>
                {itemSub.type == 'black' ? (
                  <span className="black">{isSourceTips ? formatMessage({ id: itemSub.strKey }) : itemSub.strKey}</span>
                ) : itemSub.type == 'yellow' ? (
                  <span className={itemSub.highColor ?? 'highlight'}>
                    {isSourceTips ? formatMessage({ id: itemSub.strKey }) : itemSub.strKey}
                  </span>
                ) : (
                  formatMessage({ id: itemSub.strKey })
                )}
              </React.Fragment>
            );
          })}
        </div>
      );
    });
  };

  const getCollapseContent = () => {
    return (
      <div className={'summary-source-metrics-explanation-content'}>
        <SvgIcon type="alert-circle-m" />
        <span className="summary-source-metrics-des">
          {formatMessage({ id: 'dbi_pcconsole_source_metrics_explanation' })}
        </span>
      </div>
    );
  };

  return (
    <CardSlotV2
      iconList={[]}
      title={
        isSourceTips
          ? formatMessage({ id: 'dbi_pcconsole_source_differences_explanation' })
          : formatMessage({ id: 'dbi_benchmark_summary' })
      }
      className={classnames('dbi-benchmark-summary', {
        'dbi-sroucetips-summary dbi-benchmark-summary': isSourceTips,
        'is-expand': openSource,
      })}
    >
      {loading ? (
        <div className="dbi-benchmark-summary-loading">
          <LoadingTip />
        </div>
      ) : (
        <>
          {strListCur?.length > 0 ? (
            <>
              {subTitle && <div className="summary-sub-title">{formatMessage({ id: subTitle })}</div>}
              <div className={!openSource && isSourceTips ? 'summary-sub-content' : ''}>
                {!isSourceTips || openSource ? getListContent() : getCollapseContent()}
                {showCloseBtn && (
                  <SvgIcon
                    className="dbi-benchmark-summary-close-icon"
                    type="clonse"
                    onClick={(e) => {
                      e?.stopPropagation();
                      onClose?.();
                    }}
                  />
                )}
                {/* {isSourceTips && <Button
                  type="link"
                  className="source-more"
                  onClick={handleOpenSource}
                >
                  {openSource ? formatMessage({ id: 'dbi_pcconsole_source_collapse' }) : formatMessage({ id: 'dbi_pcconsole_source_show' })}
                </Button>} */}
              </div>
            </>
          ) : (
            <div style={{ height: 84 }}>
              <NoData />
            </div>
          )}
        </>
      )}
    </CardSlotV2>
  );
};

export default React.memo(Summary);
